import React from 'react'
import Chekingprofile from '../../Components/admin/profile/Chekingprofile'
import Sidebar from '../../Components/admin/Sidebar/Sidebar'
function Verificationpage() {
  return (
    <>
    <Sidebar/>
    <Chekingprofile/>
    </>
  )
}

export default Verificationpage
